import usePreviousState from '@hooks/usePreviousState'
import { useEffect, useLayoutEffect } from 'react'

interface UseVideoAdControllerProps {
	/** 광고 표시 여부 */
	isShowAd: boolean
}

/**
 * 디지털캠프 동영상 광고 컨트롤러
 */
const useVideoAdController = ({ isShowAd }: UseVideoAdControllerProps) => {
	const prevIsShowAd = usePreviousState(isShowAd)

	/** 동영상 미노출 시 광고 재생 멈추도록 진행 */
	useEffect(() => {
		if (prevIsShowAd && !isShowAd) {
			window.digitalCampPlayer_121107?.pause()
			return
		}

		if (!prevIsShowAd && isShowAd) {
			window.digitalCampPlayer_121107?.play()
		}
	}, [isShowAd])

	/** digitalcamp 동영상 광고 수동 조작이 필요할 경우 사용 (첫 로드시 실행 필요) */
	useLayoutEffect(() => {
		window.MVSCR_STOP_121107 = true

		/** 페이지 이탈 시 reset (reset 안하면 background 에서 계속 실행됨) */
		return () => {
			window.digitalCampPlayer_121107?.reset()
		}
	}, [])
}
export default useVideoAdController
